import {
  TicketFile,
  TicketState,
  TicketFormData,
  InteractionProps,
} from "./types";
import { stateMachine } from "./TicketStateMachine";

export const handleSelectValue =
  (key: "priority" | "isTitleIssue", value: string | boolean) =>
  ({ prevState, optionIndex, currentState, setState }: InteractionProps) => {
    const selectedOption = stateMachine[currentState].options[optionIndex];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { dataName, stateComponent, ...rest } = prevState;
    setState({
      ...rest,
      ticketData: { ...prevState.ticketData, [key]: value },
      name: selectedOption.next,
      ...stateMachine[selectedOption.next],
      previousState: {
        ...prevState,
        selectedOption,
      },
    });
  };

export const handleInteraction = (props: InteractionProps) => {
  const selectedOption =
    stateMachine[props.currentState].options[props.optionIndex];

  const ticketData: TicketFormData = {
    ...props.prevState.ticketData,
    participant: props.participant ?? props.prevState.ticketData.participant,
    deal: props.deal ?? props.prevState.ticketData.deal,
    description: props.description ?? props.prevState.ticketData.description,
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { dataName, stateComponent, ...rest } = props.prevState;

  props.setState({
    ...rest,
    ticketData,
    inProgress: true,
    name: selectedOption.next,
    ...stateMachine[selectedOption.next],
    previousState: {
      ...props.prevState,
      ticketData,
      selectedOption,
    },
  });
};

export const handleInteractionDocuments = (
  file: TicketFile,
  state: TicketState,
  setState: (value: React.SetStateAction<TicketState>) => void
) => {
  const ticketData: TicketFormData = {
    ...state.ticketData,
    files: [...state.ticketData.files, file],
  };

  setState({
    ...state,
    ticketData,
  });
};
